var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"descriptionOfGoods"},[_c('div',{staticClass:"reportBasic-subTitle"},[_vm._v("\n    "+_vm._s(_vm.$tc('lang.factoryReport.Production_Capability'))+"\n  ")]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Product_Catalogue'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.freportProductcatalogue,"otherData":{
          mediaName: '产品目录',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportProductcatalogue',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Main_Product'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.freportMainproduct,"otherData":{
          mediaName: '主营产品',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportMainproduct',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Product_Quality_Certificate'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.freportQualitycertificate,"otherData":{
          mediaName: '产品认证证书',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportQualitycertificate',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Products_Awards'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.freportProductsawards,"otherData":{
          mediaName: '产品荣誉证书',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportProductsawards',
        },"id":_vm.id}})],1)]),_c('div',{staticClass:"desOfGoods-con"},[_c('span',[_vm._v(_vm._s(_vm.$tc('lang.factoryReport.Brochure'))+"：")]),_c('div',{staticClass:"img"},[_c('show-img',{attrs:{"data":_vm.descriptionOfGoods.freportBrochure,"otherData":{
          mediaName: '产品宣传册',
          mediaType: 3,
          personId: '',
          orderId: '',
          reportId: '',
          mediaDesc: 'freportBrochure',
        },"id":_vm.id}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }